/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spinner[_ngcontent-%COMP%]{z-index:999999;display:flex;background:#000000c7!important;position:absolute;color:#000;height:100vh;width:100%;align-items:center;justify-content:space-around;top:0;bottom:0}"];
export { styles as styles };
